import { useState } from 'react';
import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/home';
import { allNewsCategories } from '@/mocks/articles';

export default function NewsSection() {
  const [activeCategory, setActiveCategory] = useState('全部');

  const filteredArticles = activeCategory === '全部'
    ? newsArticles
    : newsArticles.filter((a) => a.category === activeCategory);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-10 md:mb-14">
          <div>
            <p className="text-xs font-semibold text-secondary-500 tracking-widest uppercase mb-2 font-label">新闻资讯</p>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
              最新动态
            </h2>
          </div>
          <div className="flex items-center gap-1 flex-wrap">
            {allNewsCategories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className={`px-3 py-1.5 text-xs font-medium rounded-full transition-all duration-200 whitespace-nowrap ${
                  activeCategory === cat
                    ? 'bg-secondary-500 text-white'
                    : 'bg-background-100 text-foreground-500 hover:bg-secondary-100 hover:text-secondary-700'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {filteredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/60 rounded-lg overflow-hidden hover:border-secondary-200 transition-all duration-300"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2 py-0.5 rounded-full bg-black/50 backdrop-blur-sm text-white text-[10px] font-medium">
                  {article.category}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold font-heading text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <span className="text-[11px] text-foreground-400">{article.date}</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/news"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-secondary-100 text-sm text-secondary-700 hover:bg-secondary-200 transition-all duration-200"
          >
            查看全部资讯 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}